import { Column, TableProperties, Workbook, Worksheet } from "exceljs";
import { MimicExcelColumn } from "./types";

export type ExportToExcelProps = {
  modify?: (workbook: Workbook, worksheet: Worksheet) => Promise<void> | void,
  tableProps?: TableProperties,
  frozenRows?: number,
  worksheetName?: string,
}

export function createExcelWorksheet(workbook: Workbook, worksheetName?: string, frozenRows?: number) {
  return workbook.addWorksheet(worksheetName || "Sheet", {
    pageSetup: {
      orientation: "landscape",
    },
    views: [ {
      state: "frozen",
      ySplit: frozenRows || 1,
    } ],
  });
}

export function addExcelFullPageTable<T>(worksheet: Worksheet, data: T[], columns: MimicExcelColumn<T>[], tableProps?: TableProperties) {
  worksheet.columns = columns as any as Column[];

  worksheet.addTable({
    name: "Table_" + Date.now(),
    ref: "A1",
    headerRow: true,
    style: {
      theme: "TableStyleLight1",
      showRowStripes: true,
    },
    totalsRow: columns.some(x => x.totalsRowFormula || x.totalsRowFunction || x.totalsRowLabel),
    columns,
    rows: data.map(row => columns.map(column => column.cellAccessor(row))),
    ...tableProps,
  });

  worksheet.columns.forEach((tableColumn, index) => {
    if (columns[index].numFmt) {
      tableColumn?.eachCell?.((cell, rowNumber) => {
        if (rowNumber > 1) {
          cell.numFmt = columns[index].numFmt as string;
        }
      });
    }
  });
}

function createWorkBook() {
  const workbook = new Workbook();
  workbook.creator = "Tecorien";
  workbook.lastModifiedBy = "Tecorien";
  workbook.created = new Date();
  workbook.modified = new Date();
  workbook.properties.date1904 = true;
  workbook.calcProperties.fullCalcOnLoad = true;
  return workbook;
}

export async function exportToExcel<T>(
  data: T[],
  columns: MimicExcelColumn<T>[],
  restProps?: ExportToExcelProps,
) {
  const workbook = createWorkBook();
  const worksheet = createExcelWorksheet(workbook, restProps?.worksheetName, restProps?.frozenRows);
  addExcelFullPageTable(worksheet, data, columns, restProps?.tableProps);

  await restProps?.modify?.(workbook, worksheet);

  return await workbook.xlsx.writeBuffer();
}

export async function exportToSimpleExcel<T>(data: T[]) {
  const workbook = createWorkBook();
  const worksheet = createExcelWorksheet(workbook);
  worksheet.addRows(data);

  return await workbook.xlsx.writeBuffer();
}
